import type { VariantImagesDefinition } from 'types/images'

import { M01_IMAGES } from './default'

export const M01_MEMOJI_DARK_IMAGES = {
  ...M01_IMAGES,
  welcomeAgeBuckets: {
    ...M01_IMAGES.welcomeAgeBuckets,
    heroBackground: {
      width: 651,
      height: 651,
      srcSet: [
        '/images/m01/memoji-dark/welcome-age-buckets/hero_background.webp',
        '/images/m01/memoji-dark/welcome-age-buckets/hero_background@2x.webp',
      ],
    },
  },
  strugglePitch: {
    knees: {
      ...M01_IMAGES.strugglePitch.knees,
      srcSet: [
        '/images/m01/memoji-dark/struggle-pitch/struggle_pitch_knees.webp',
        '/images/m01/memoji-dark/struggle-pitch/struggle_pitch_knees@2x.webp',
      ],
    },
    back: {
      ...M01_IMAGES.strugglePitch.back,
      srcSet: [
        '/images/m01/memoji-dark/struggle-pitch/struggle_pitch_back.webp',
        '/images/m01/memoji-dark/struggle-pitch/struggle_pitch_back@2x.webp',
      ],
    },
    both: {
      ...M01_IMAGES.strugglePitch.both,
      srcSet: [
        '/images/m01/memoji-dark/struggle-pitch/struggle_pitch_both.webp',
        '/images/m01/memoji-dark/struggle-pitch/struggle_pitch_both@2x.webp',
      ],
    },
  },
} satisfies VariantImagesDefinition<typeof M01_IMAGES>
